/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-regex-literals */
/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint no-use-before-define: 0 */
import React from "react";

const Button = props => {
  const { children, format, active, ...rest } = props;
  return (
    <button
      className={`toolbar-btn ${active ? "btnActive" : ""}`}
      title={format}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
